import React from 'react';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { FormControl, InputLabel, OutlinedInput } from '@mui/material';

interface ITextBoxProps {
    name: string;
    id: string;
    label: string;
    defaultValue?: string | null | undefined;
    type?:string;
    control: Control<any>;
    errors: FieldErrors<any>; // Errors from react-hook-form
    required?: boolean;
    width?: any,
    disabled?: boolean;
}

const TextBox = ({ name, id, label, defaultValue = '', control, errors, required = true, width = '25ch', type="text", disabled=false }: ITextBoxProps) => {
    return (
        <>
            <FormControl sx={{ m: 1 }} variant="outlined">
                <InputLabel htmlFor={id}>{label}</InputLabel>
                <Controller
                    name={name}
                    control={control}
                    defaultValue={defaultValue}
                    render={({ field }) => (
                        <OutlinedInput
                            {...field}
                            required={required}
                            id={id}
                            label={label}
                            type={type}
                            disabled={disabled}
                            error={!!errors[name]} // Mark the field as having an error if it exists
                        />
                    )}
                />
            </FormControl>
        </>
    );
};

export default TextBox;
